import { mapMutations } from "vuex";

export default class dateHelper {
    static parseIntDate(date) {
        let aux = date.split("/").reverse();
        let arrayDate = [];

        for(let value in aux) {
            arrayDate.push(parseInt(aux[value]));
        }

        return arrayDate;
    }
    // recebe data no formato yyyy-mm-dd e retorna dd MM yyyy
    static formataDataString(dataIso) {
        let data = new Date(dataIso)
        const mes = ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"];
        return data.getDate() + ' ' + mes[data.getMonth()] + ' ' + data.getFullYear()
    }
    // recebe duas datas no formato yyyy-mm-dd
    static comparaDataString(data, hoje, separador = '-') {
        
    }
}


// WEBPACK FOOTER //
// ./src/utils/date-helper.js